import React, { useEffect, useState } from 'react';
import { useDispatch, useIntl, useSelector } from 'umi';
import { useSyncCopilotLeftMenuCollapse } from '@/pages/aigc/pages/Agent/hooks/useCopilotLeftMenuCollapsed';

import FoldButton from '@/pages/dashboard/components/FoldButton';
// import { ENV } from '@/pages/home/_config/config';

// navmenu相关样式在pages/dashboard/assets/scss/components/navigation/navigation.scss
import './index.scss';
import NavBody from './components/nav-body';
import NavHeader from './components/nav-header';
import LoadingCommon from '../LoadingCommon';
import { getReportInfo } from './getRoprtInfo';

const routeHelpers: any = {
  'Key Metrics (Real-time)': {
    newPath: 'RealtimeOpinions',
  },
  'Real-time Key Metrics': {
    newPath: '/Overview/RealtimeOpinions',
  },
  'Real-time Streaming': {
    newPath: '/Realtime/RealtimeStreaming',
  },
  Summary: {
    icon: 'nav-summary',
  },
  'Topic Analysis': {
    newPath: 'Summary/TopicTracking',
    icon: 'nav-summary',
  },
  'Hot Event': {
    newPath: '/Summary/HotEvent',
  },
  Overview: {
    icon: 'application',
  },
  Report: {
    icon: 'market-reports',
  },
  Performance: {
    newPath: '',
  },
  'Trending Publications': {
    icon: 'trend-publication',
  },
  'Game Store': {
    icon: 'office',
  },
  'Keyword & Topic Analysis': {
    newPath: 'KeywordAnalysis',
  },
  'Keyword & URL Analysis': {
    newPath: 'KeywordAndURLAnalysis',
  },
  Guidelines: {
    icon: 'clipboard-m',
    newPath: 'MonitorScope',
  },
  Stats: {
    icon: 'camera',
    defaultOpened: false,
  },
  Feeds: {
    icon: 'information',
    newNameCn: '评论/资讯详情',
  },
  Community: {
    icon: 'smile',
  },
  Competitor: {
    icon: 'competitor-full',
  },
  Compare: {
    icon: 'vs-icon',
  },
  'Custom Comparison': {
    newPath: 'Compare',
  },
  'Compare Key Metrics': {
    newPath: '/Overview/CompareKeyMetrics',
  },
  'Competitor Landscape': {
    newPath: 'Compare',
    icon: 'vs-icon',
  },
  'Competitor Benchmarking': {
    newPath: '',
  },
  'Key Opinions AI Analysis': {
    newPath: 'KeyOpinions',
  },
  // 'Real-time Opinions': {
  //   icon: 'monitor',
  // },
  Accounts: {
    icon: 'menu-account',
    defaultOpened: false,
  },
  'Official Accounts': {
    icon: 'menu-account',
    defaultOpened: false,
    newPath: 'Accounts',
  },
  'Sources and Metrics': {
    icon: 'multiple-folds',
    defaultOpened: false,
    newPath: 'DataMap',
  },
  Sources: {
    newPath: 'OpinionsSources',
  },
  Metrics: {
    newPath: 'OpinionsMetrics',
  },
  'Google & X Trends': {
    icon: 'smile-happy-icon',
    newPath: 'Trends',
  },
  'AI Analysis Hub': {
    icon: 'ai-robot',
  },
  'AI Auto Report': {
    newPath: 'GPT Auto Report',
    newNameEn: 'AI Auto Report',
    newNameCn: 'AI 智能报告',
  },
  'Region/Country': {
    newPath: 'Region',
  },
  'By Channel': {
    newNameCn: '分渠道统计',
  },
  'By Account': {
    newNameCn: '分官号统计',
  },
  News: {
    icon: 'nav-news',
  },
  'Steam Performance': {
    icon: 'steam-icon',
  },
  Influencer: {
    icon: 'influencer-menu',
  },
  'Customized Reports': {
    icon: 'customized',
  },
  "Ad Delivery Overview": {
    icon: 'game-arrows',
  },
};

const disableds: string[] = [
  // 'Competitor',
  'Alert',
  'Alert Feeds',
  // 'Keyword Correlation',
  // 'Hot Content',
  'Potential KOL',
];

const blackParents: string[] = ['Alert'];

const localBlackChildren: string[] = ['Potential KOL'];

// if (['pro'].includes(ENV)) {
//   localBlackChildren.push('Hot Event');
// }

export const blackChildren: string[] = localBlackChildren;

export default function LeftMenu({
  gameInfo,
  wholeGameInfo,
  listMenu,
  loading,
  hideGameListMenu
}: any) {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const { edition_unified_id, entity_type, id_type } = gameInfo;
  const [empty, setEmpty] = useState(false);
  const [menuList, setMenuList] = useState<any[]>([]);

  function getBateNewsIcon(item: {
    ext_info: string;
    show_new_icon: '0' | '1' | '2';
  }) {
    let showNew = item.show_new_icon === '1';
    let showBeta = item.show_new_icon === '2';

    if (item.ext_info !== '') {
      try {
        const { beta_icon, new_icon } = JSON.parse(item.ext_info || '{}');
        if (beta_icon) {
          showBeta = beta_icon.includes(entity_type);
        }
        if (new_icon) {
          showNew = new_icon.includes(entity_type);
        }
      } catch (error) { }
    }

    return {
      showNew: showBeta ? false : showNew,
      showBeta,
    };
  }

  function getUrlInfo(
    hasLock: boolean,
    name_en: string,
    routeHelper: { newPath: string },
  ) {
    const realName = name_en?.replaceAll(/\s/gi, '');
    const defaultPath = routeHelper?.newPath ?? realName;
    return hasLock ? `Lock/${realName}` : defaultPath;
  }

  const dealListMenu = (originList: any) => {
    let newList = [...originList];

    const buildMenu = (item: any, parent: any = null, isTreeLevel = false) => {
      const { id, name_cn, name_en, opinion_list = [], has_permissions } = item;
      const hasLock = has_permissions === '-1';
      const routeHelper = routeHelpers[name_en];
      const { showNew, showBeta } = getBateNewsIcon(item);
      let newItem: any = {
        ...item,
        id,
        showNew,
        showBeta,
        showLock: hasLock,
        name_cn: routeHelper?.newNameCn ?? name_cn,
        name_en: routeHelper?.newNameEn ?? name_en,
        title: name_cn,
        icon: routeHelper?.icon,
        path: getUrlInfo(hasLock, name_en, routeHelper),
        disabled: disableds.includes(name_en),
        defaultOpened: routeHelper?.defaultOpened ?? true,
      };

      if (parent === null) {
        newItem.listMenu = opinion_list
          ?.filter((item: any) => !blackChildren.includes(item.name_en))
          ?.filter((item: any) => {
            // 特殊逻辑：非 mobile 游戏没有 Version
            if (item.name_en === 'Version' && gameInfo.entity_type !== 'mobile')
              return false;

            return true;
          })
          ?.map?.((childItem: any) => buildMenu(childItem, newItem));

        newItem.pathname = `/opinion/${newItem.path}`;
        newItem.actualPath = newItem.pathname;

        // 特殊处理 Feeds
        if (name_en === 'Feeds') {
          newItem.listMenu = null;
          newItem.pathname = `/opinion/${newItem.path}/Feeds`;
          newItem.actualPath = newItem.pathname;
        }
        return newItem;
      }

      if (hasLock) {
        newItem.pathname = `/opinion/${getUrlInfo(true, name_en, routeHelper)}`;
        newItem.actualPath = newItem.pathname;

        return newItem;
      }

      if (newItem.path?.startsWith?.('/')) {
        newItem.pathname = `/opinion${newItem.path ? `${newItem.path}` : ''}`;
      } else {
        // 子路由可以调整
        newItem.pathname = `/opinion/${parent.path}${newItem.path ? `/${newItem.path}` : ''
          }`;
      }
      newItem.actualPath = newItem.pathname;
      if (parent.name_en === 'Report') {
        newItem = getReportInfo(newItem, name_en);
      }

      if (newItem.name_en === 'Hero') {
        newItem.pathname = '/opinion/Hero';
        newItem.actualPath = newItem.pathname;
      }

      if (isTreeLevel) {
        newItem.pathname = `${parent.pathname}/${newItem.path}`;
        newItem.actualPath = newItem.pathname;
      }

      if ((opinion_list || []).length === 0) {
        return newItem;
      }

      newItem.listMenu = opinion_list?.map?.((childItem: any) =>
        buildMenu(childItem, newItem, true),
      );

      return newItem;
    };

    newList = newList
      .filter((item) => !blackParents.includes(item.name_en))
      .map((item: any) => {
        return buildMenu(item);
      });
    setMenuList(newList);
  };

  useEffect(() => {
    setEmpty(
      !wholeGameInfo?.opinion_permissions || !wholeGameInfo?.opinion_game,
    );
  }, [wholeGameInfo]);

  useEffect(() => {
    if (listMenu?.length > 0) {
      dealListMenu(listMenu);
    }
  }, [listMenu]);

  // 遮盖逻辑后续补上
  const [showContentMask, setShowContentMask] = useState(false);

  const { menuExpand: isExpand, selectMenuItem } = useSelector((state: any) => {
    const {
      opinionMenu: { menuExpand, selectMenuItem },
    } = state;
    return { menuExpand, selectMenuItem };
  });

  useSyncCopilotLeftMenuCollapse((expanded) => {
    dispatch({
      type: 'opinionMenu/toggleMenuExpand',
      payload: { menuExpand: expanded },
    });
  });

  function toggleExpand() {
    dispatch({
      type: 'opinionMenu/toggleMenuExpand',
    });
  }

  // menuWidth会变化，可参考经分

  const menuWidth = 250;

  const [showBottomBtn, setShowBottomBtn] = useState(false);

  return (
    <div
      className={`navmenu dbo-navmenu ${isExpand ? 'normal-with' : 'small-with'
        }`}
      onMouseEnter={() => {
        !showBottomBtn && setShowBottomBtn(true);
      }}
      onMouseLeave={() => {
        showBottomBtn && setShowBottomBtn(false);
      }}
    >
      <NavHeader
        isExpand={isExpand}
        toggleExpand={toggleExpand}
        listMenu={menuList}
        hideGameListMenu={hideGameListMenu}
        wholeGameInfo={wholeGameInfo}
      />

      {empty || loading ? (
        <LoadingCommon
          status={loading ? 'loading' : 'empty'}
          style={{ height: 200 }}
          emptyText={formatMessage({ id: 'No permission currently' })}
        ></LoadingCommon>
      ) : (
        <NavBody
          isExpand={isExpand}
          setIsExpand={toggleExpand}
          menuList={menuList}
          selectMenuItem={selectMenuItem}
        />
      )}

      <div className="navmenu-ft">
        <div className="navmenu-ft-left"></div>
        <div
          className="navmenu-ft-right"
          style={{
            display: showBottomBtn ? 'flex' : 'none',
          }}
          onClick={() => toggleExpand()}
        >
          <FoldButton isExpand={isExpand} />
        </div>
      </div>

      {/* 开发需补逻辑：点击游戏切换按钮需展示mask，menuWidth会变化，参考经分(关键词showContentMask) */}
      {showContentMask && (
        <div
          className="db-content-mask"
          style={{ left: `${menuWidth - 1}px` }}
        ></div>
      )}
    </div>
  );
}
